import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-helpCenter",
  "use": "icon-helpCenter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-helpCenter\"><defs><style type=\"text/css\"></style></defs><path d=\"M848.928 170.656H634.56a153.184 153.184 0 0 0-122.464 61.312 153.184 153.184 0 0 0-122.496-61.312H175.104c-33.792 0-61.312 27.52-61.312 61.312v566.656c0 33.792 27.52 61.312 61.312 61.312h225.216a160.032 160.032 0 0 0 111.776 45.888 160.032 160.032 0 0 0 111.776-45.888h225.056c33.792 0 61.312-27.52 61.312-61.312V232c0-33.792-27.52-61.312-61.312-61.312z m0 627.968h-238.4a30.4 30.4 0 0 0-23.2 10.72 99.392 99.392 0 0 1-75.232 35.168 99.392 99.392 0 0 1-75.232-35.2 30.4 30.4 0 0 0-23.232-10.688H175.104V232h214.368a92.064 92.064 0 0 1 91.872 91.904v260.384a30.56 30.56 0 1 0 61.184 0v-260.384a92.064 92.064 0 0 1 91.872-91.904h214.528v566.656z\" p-id=\"3657\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/helpCenter.svg
// module id = OQVf
// module chunks = 182